import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import { getCurrentMember } from '../../utils/user.utils';
import { useFeatureFlag } from '../useFeatureFlag';

export const useSuppressNiceMembers = () => {
  const [enableSuppressionForEniNice, enableSuppressionForUspNice] =
    useFeatureFlag([
      ConstantsLagoon.FEATURE_FLAGS.ENABLE_SUPRESSION_FOR_ENI_NICE,
      ConstantsLagoon.FEATURE_FLAGS.ENABLE_SUPRESSION_FOR_USP_NICE,
    ]);

  const currentMember = getCurrentMember();

  const suppressForEniNice =
    !!enableSuppressionForEniNice && !!currentMember?.isEniNiceMember;

  const suppressForUspNice =
    !!enableSuppressionForUspNice && !!currentMember?.isUspNiceMember;

  return {
    suppressForNiceMembers: suppressForEniNice || suppressForUspNice,
    suppressForEniNice,
    suppressForUspNice,
  };
};
